import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import {
    IconButton,
    Hidden,
    makeStyles,
    Tooltip,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MobileTabsDrawer from 'components/widgets/MobileTabsDrawer';

const useStyles = makeStyles((theme) => ({
    nav: {
        border: 'none',
        [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
            flex: 1,
            overflow: 'auto',
            display: 'block',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            overflowY: 'hidden',
            '& .nav-item': {
                display: 'inline-block',
            },
        },
    },
    navLink: {
        textDecoration: 'none',
        border: 'none !important',
        borderBottom: '2px solid transparent !important',
        color: `${theme.palette.text.minsk} !important`,
        fontWeight: '500',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        '&.active': {
            borderBottom: `2px solid ${theme.palette.background.fruitSalad} !important`,
        },
    },
    menuButton: {
        marginLeft: 'auto',
        marginRight: '12px',
        '& svg': {
            fontSize: '1.8rem',
        },
    },
}));

const ResponsiveTabsNav = (props) => {
    const {
        tabs,
        activeTab,
        onTabSelect,
        showMobileDrawer,
        navClassName,
        navLinkClassName,
    } = props;

    const classes = useStyles();
    const [openDrawer, setOpenDrawer] = useState(false);

    const toggleDrawer = (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenDrawer(!openDrawer);
    };

    const handleTabSelect = (tabIndex) => {
        onTabSelect(tabIndex);
        setOpenDrawer(false);
    };

    return (
        <>
            <Hidden smDown>
                <Nav variant="tabs" className={navClassName || classes.nav}>
                    {tabs.map((item, index) => (
                        <Tooltip
                            key={index}
                            title={item.disabled ? 'Insufficient permissions. Please contact the HR department for access' : ''}
                            disableHoverListener={!item.disabled}
                            placement="bottom-start"
                        >
                            <span>
                                <Nav.Item key={index}>
                                    <Nav.Link
                                        className={navLinkClassName || classes.navLink}
                                        eventKey={index}
                                        disabled={item.disabled}
                                    >
                                        {item.title}
                                    </Nav.Link>
                                </Nav.Item>
                            </span>
                        </Tooltip>
                    ))}
                </Nav>
            </Hidden>
            {showMobileDrawer && (
                <>
                    <Hidden mdUp>
                        <IconButton
                            edge="end"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="open drawer"
                            onClick={toggleDrawer}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <MobileTabsDrawer
                        open={openDrawer}
                        onClose={() => setOpenDrawer(false)}
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabSelect={handleTabSelect}
                    />
                </>
            )}
        </>
    );
};

ResponsiveTabsNav.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
    })).isRequired,
    activeTab: PropTypes.number.isRequired,
    onTabSelect: PropTypes.func.isRequired,
    showMobileDrawer: PropTypes.bool,
    navClassName: PropTypes.string,
    navLinkClassName: PropTypes.string,
};

ResponsiveTabsNav.defaultProps = {
    showMobileDrawer: true,
    navClassName: null,
    navLinkClassName: null,
};

export default ResponsiveTabsNav;
